import { render, staticRenderFns } from "./RouterTabs.vue?vue&type=template&id=7900b489&scoped=true"
import script from "./RouterTabs.vue?vue&type=script&lang=js"
export * from "./RouterTabs.vue?vue&type=script&lang=js"
import style0 from "./RouterTabs.vue?vue&type=style&index=0&id=7900b489&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7900b489",
  null
  
)

export default component.exports